import React from "react";
import Icon from "./icon";

const DynamicIcon = React.forwardRef(({onClick, onMouseDown, name, size, color}, ref) => {
  return (
    <div ref={ref} onClick={onClick} onMouseDown={onMouseDown} className={`${color} ${onClick || onMouseDown ? 'cursor-pointer' : ''}`}>
        <Icon name={name} size={size} color='currentColor' />
    </div>
  );
});

DynamicIcon.displayName = 'DynamicIcon';

export default DynamicIcon;
